const React = require("react");
const ChakraProvider = require("@chakra-ui/react").ChakraProvider;
const theme = require("./theme").default;

exports.wrapRootElement = ({ element }) => {
  return (
    <ChakraProvider resetCss theme={theme}>
      {element}
    </ChakraProvider>
  );
};

exports.shouldUpdateScroll = () => false;
